import PAText from "component/design-system/typography/PAText/PAText";
import ReadMore from "component/read-more/ReadMore";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { isOEHP } from "util/helper/helper";
import styles from "./bannerDescription.module.scss";

interface IProps {
  description: string;
  className?: string;
}

function BannerDescription(props: IProps) {
  const { description, className = "" } = props;
  const router = useRouter();
  const { asPath } = router;
  const isOEPage = isOEHP(asPath);
  const { t } = useTranslation("category");

  if (!description) {
    return null;
  }

  if (isOEPage) {
    return (
      <div className={`${styles.container} ${className}`}>
        <div>
          <PAText>
            {t("Search and find OEM quality replacement parts for your car")}
          </PAText>
          <br />
          {" "}
          <br />
          <PAText bold>
            {t("What are aftermarket parts")}
            {" "}
            ?
          </PAText>
          <PAText inlineBlock>
            {t("OE_Para_1")}
          </PAText>
          <br />
          {" "}
          <br />
          <PAText inlineBlock>
            {t("OE_Para_2")}
          </PAText>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <ReadMore text={description} lineClamp={4} />
    </div>
  );
}

export default BannerDescription;
